import axios from 'axios';
import { getAuthToken, getPortalType } from '@/utils/auth';
import { apiUrl } from './config';

/**
 * Get authentication headers
 */
const getAuthHeaders = () => {
  const portal = getPortalType(window.location.pathname || '');
  const token = getAuthToken(portal);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * Basic Concepts API
 */
export const basicConceptsAPI = {
  /**
   * Get Basic Concepts content for a chapter
   * @param {number} chapterId - The chapter ID
   * @returns {Promise} Basic Concepts data with user progress
   */
  getChapterBasicConcepts: async (chapterId) => {
    try {
      const response = await axios.get(
        apiUrl(`core/chapters/${chapterId}/basic-concepts/`),
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching Basic Concepts:', error);
      throw error;
    }
  },

  /**
   * Get user's progress for Basic Concepts in a chapter
   * @param {number} chapterId - The chapter ID
   * @returns {Promise} User progress data
   */
  getProgress: async (chapterId) => {
    try {
      const response = await axios.get(
        apiUrl(`core/chapters/${chapterId}/basic-concepts-progress/`),
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching Basic Concepts progress:', error);
      throw error;
    }
  },

  /**
   * Update user's progress for Basic Concepts
   * @param {number} chapterId - The chapter ID
   * @param {Object} progressData - Progress data to update
   * @returns {Promise} Updated progress data
   */
  updateProgress: async (chapterId, progressData) => {
    try {
      const response = await axios.patch(
        apiUrl(`core/chapters/${chapterId}/basic-concepts-progress/`),
        progressData,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating Basic Concepts progress:', error);
      throw error;
    }
  },
};
